
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M.75 17.25l3-12.918A4.5 4.5 0 018.159.75h7.682a4.5 4.5 0 014.4 3.582l3 12.918"}}),_c('path',{attrs:{"d":"M20.25 17.25l-3-9.75v9.75a1.5 1.5 0 01-1.5 1.5h-7.5a1.5 1.5 0 01-1.5-1.5V7.5l-3 9.75m3-1.5h10.5M8.16.75S8.25 4.5 12 4.5 15.841.75 15.841.75"}})])])
          )
        }
      }
    